<template>
  <section class="app-transporte">
    <v-container grid-list-xl>
      <v-layout row wrap>
        <v-flex lg12 sm12 xs12>
          <v-card outlined class="app-card">
            <v-card-title class="app-card-title">Recuperar Senha</v-card-title>
            <v-card-text class="app-card-content">
              <v-form ref="formRef" lazy-validation @submit.prevent="onSubmit">
                <v-row>
                  <v-col :md="12" :sm="12" :xs="12" cols="12">
                    <v-text-field
                      v-model="formRef.email"
                      placeholder="Digite seu Email para recuperação"
                      label="Email *"
                      :rules="[rules.required, rules.validEmail]"
                      filled
                      rounded
                      dense
                    ></v-text-field>
                    <br/>
                    <router-link :to="isEntidade ? '/carteira-macrorregiao/login-entidade' : '/carteira-macrorregiao/login-grafica'">
                      <a><v-icon small color="blue">call_made</v-icon>Voltar</a>
                    </router-link>
                  </v-col>
                  <v-col :md="9" :sm="9" :xs="12" cols="12">
                    <vue-recaptcha
                      ref="recaptcha"
                      :sitekey="siteKey"
                      :loadRecaptchaScript="true"
                      @verify="verifyRecaptcha"
                      @expired="expiredRecaptcha"
                      class="recaptcha"
                    ></vue-recaptcha>
                    <v-input
                      v-model="formRef.recaptcha"
                      :rules="[rules.required]"
                    ></v-input>
                  </v-col>
                  <v-col :md="3" :sm="3" :xs="12" cols="12">
                    <v-btn depressed block large color="primary" type="submit"
                    >Continuar</v-btn
                    >
                  </v-col>
                </v-row>
              </v-form>
              <div class="loading" v-if="isLoading">
                <v-progress-circular
                  :size="25"
                  color="primary"
                  indeterminate
                ></v-progress-circular>
              </div>
            </v-card-text>
          </v-card>
        </v-flex>
      </v-layout>
      <v-layout> </v-layout>
    </v-container>
  </section>
</template>

<script>
import VueRecaptcha from "vue-recaptcha";
import { VUE_APP_RECAPTCHA_KEY } from "@/commons/config";
import GlobalStore from "@/store/modules/global";
import AuthService from "@/services/sie-pedidos/auth.service";

export default {
  components: {
    VueRecaptcha
  },
  data: () => ({
    siteKey: VUE_APP_RECAPTCHA_KEY,
    isLoading: false,
    formRef: {
      email: "",
      recaptcha: null,
    },
    rules: {
      required: (value) => !!value || "Esse campo deve ser preenchido",
      validEmail: (value) => {
        const pattern = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
        return pattern.test(value) || "E-mail inválido!";
      },
    },
    openDialog: "",
    alert: false,
    msg: "",
    isEntidade: AuthService.isEntidadeRecuperarSenha()
  }),
  metaInfo: {
    title: "SIE",
  },
  methods: {
    verifyRecaptcha(value) {
      this.formRef.recaptcha = value;
    },
    expiredRecaptcha() {
      this.$refs.recaptcha.reset();
      this.formRef.recaptcha = null;
    },
    onSubmit() {
      const isValid = this.$refs.formRef.validate();
      if (isValid) {
        this.isLoading = true;
        const {email} = this.formRef;
        AuthService.recuperarSenha(email).subscribe(
          (res) => {
            GlobalStore.setSnackBar({
              show: true,
              message:  'Um email com um link para mudar sua senha foi enviado em seu email.',
              type: "success",
            });
            this.isLoading = false;
            this.formRef.email = null
            this.expiredRecaptcha()
            this.$refs.formRef.reset()
          },
          (err) => {
            this.isLoading = false;
            this.alert = true;
            this.msg = err.msg;
          }
        )
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.loading {
  position: absolute;
  top: 0;
  width: 100%;
  height: 100%;
  background: rgba(255, 255, 255, 0.8);
  display: flex;
  align-items: center;
  text-align: center;
  .v-progress-circular {
    margin: auto;
  }
}
</style>

